import styles from './FilterLayout.module.scss'
import { SelectOption } from '@src/types';
import Search from 'src/components/search/unit-search/UnitSearch';
import Button from 'src/components/button/Button';
import IconRotating from 'src/assets/icons/rotating_arrow.svg?react';
import GradeIcon from 'src/assets/icons/grade_icon.svg?react';
import { collectionTypeOptions, superAdminStandaloneLessonsAgeOptions, unitOptions } from '@src/constants';
import Select from '@src/components/select/Select';
import { useMemo } from 'react';

type Props = {
    country: string
    keyword: string
    ageGroup?: string
    handleChangeSearch: (value: string) => void
    handleChangeCourse?: (value: string) => void;
    handleChangeAgeGroup: (value: string) => void
    handleChangeCountry: (option: SelectOption) => void
    handleResetFilters: () => void
    hideCourse?: boolean;
    course?: string
    setCourses?: (courses: string[]) => void
    coursesOptions?: SelectOption[]
    gradeSort?: boolean;
    isMultiCollection?: boolean;
    isSingleCollection?: boolean;
    unitType?: string;
    collectionType?: string;
    handleChangeUnitType?: (option: SelectOption) => void   // need on Multi Collections
    handleChangeCollectionType?: (option: SelectOption) => void // need on Multi Collections
}

const countryOptions = [
  {label: "Australia", value: "Australia"},
  {label: "USA", value: "USA"},
  {label: "Canada", value: "Canada"},
  {label: "Canada & USA", value: "Canada & USA"},
]

function CollectionFilterLayout(props: Props) {
    const {
      keyword,
      country,
      ageGroup,
      course,
      coursesOptions,
      gradeSort,
      isMultiCollection = false,
      isSingleCollection = false,
      unitType,
      collectionType,
      handleChangeAgeGroup,
      handleChangeCountry,
      handleResetFilters,
      handleChangeSearch,
      handleChangeCourse,
      handleChangeUnitType,
      handleChangeCollectionType,
     } = props

    const handleAgeGroup = (v: SelectOption) => {
      handleChangeAgeGroup(v.value);
    };

    const filterStyles = useMemo(() => {
      const classes = [styles.filters];
      if (!gradeSort) {
        classes.push(styles.noneSortColumns)
      }
      if (isSingleCollection) {
        classes.push(styles.singleCollectionColumns)
      }
      if (isMultiCollection) {
        classes.push(styles.multiCollectionColumns)
      }
      return classes.join(' ');
    }, [gradeSort, isSingleCollection, isMultiCollection])
  
    return (
        <div className={styles.filterBanner}>
        <div className={filterStyles}>
          <Search placeholder="Name" onChange={handleChangeSearch} value={keyword} />
          <div className={styles.selectGroup}>
          {coursesOptions && handleChangeCourse ? (
              <Select inline={false} label={'Program'}
                options={coursesOptions}
                onChange={(v: any) => handleChangeCourse(v.value)}
                value={course}
                className={styles.fullWidth}
              />
            ) : null}
            {isMultiCollection ? <>
              <Select showSearch={false} inline={false} value={unitType} onChange={handleChangeUnitType} placeholder={'Lesson/Collection'}
                label={'Lesson/Collection'} options={unitOptions} className={styles.fullWidth}/>
              <Select disabled={unitType === unitOptions[0].value} showSearch={false} inline={false} value={collectionType} onChange={handleChangeCollectionType} placeholder={'Collection Type'}
              label={'Collection Type'} options={collectionTypeOptions} className={styles.fullWidth}/>
            </> : null}
            <Select showSearch={false} inline={false} value={country} onChange={handleChangeCountry} placeholder={'Country'}
              label={'Country'} options={countryOptions} className={styles.fullWidth}/>
            <Select
                label={'Age Group'}
                options={superAdminStandaloneLessonsAgeOptions}
                value={ageGroup}
                onChange={handleAgeGroup}
                doNotSort={true}
                inDropDown={true}
                className={styles.fullWidth}
              />
          </div>
          <div>
            {gradeSort && <div className={styles.itemContainer}>
              <GradeIcon/><label>Grade</label>
            </div>}
            <Button onClick={handleResetFilters} className={styles.resetBtn} label={'Reset'}
              size={'extraSmall'} outline={true} color={'green'}
              leftIcon={<IconRotating className={styles.resetIcon} />} />
          </div>
        </div>
        {/* <div className={styles.actions}>
          <div className={styles.clearButton} onClick={handleRemoveAllUnits}>Clear All<ArrowDownIcon className={styles.filterIcon} /></div>
          <div className={styles.addButton} onClick={handleAddAllUnits}>Add All<ArrowDownIcon className={styles.filterIconUp} /></div>
        </div> */}
      </div>
    )
}

export default CollectionFilterLayout